/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Faq_A2Inputs */

const en_dr_faq_a2 = /** @type {(inputs: Dr_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Only the room owner's plan spends quota (rooms/month, AI runs); writing cards, voting and reading the summary cost guests nothing.`)
};

const id_dr_faq_a2 = /** @type {(inputs: Dr_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya. Hanya paket pemilik ruang yang memotong kuota (ruang/bulan, jalan AI); menulis kartu, vote, dan membaca ringkasan tidak dikenakan biaya untuk tamu.`)
};

/**
* | output |
* | --- |
* | "Yes. Only the room owner's plan spends quota (rooms/month, AI runs); writing cards, voting and reading the summary cost guests nothing." |
*
* @param {Dr_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_faq_a2 = /** @type {((inputs?: Dr_Faq_A2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Faq_A2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_faq_a2(inputs)
	return en_dr_faq_a2(inputs)
});